export const settingsCertificationEn = {
  shared: {
    editDisplayOrder: "Edit display order",
    actionsColumn: {
      disableButton: "Deactivate",
      enableButton: "Activate",
      deleteButton: "Delete",
    },
    DeleteDialog: {
      title: "Delete {{name}}?",
      description:
        "If you use {{name}}, you cannot delete master name. This operation cannot be undone.",
      cancelButton: "Cancel",
      permanentlyDeleteButton: "Permanently Delete",
    },
    DisableDialog: {
      title: "Deactivate {{name}}?",
      description:
        "If you deactivate {{name}}, you will not use it anymore. The data will not be deleted and can view it in past data. You can activate it again.",
      cancelButton: "Cancel",
      disableButton: "Deactivate",
    },
    EnableDialog: {
      title: "Activate {{name}}?",
      description:
        "If you activate {{name}}, you can use it again. The previously deactivated data will be restored to active status and available for use.",
      cancelButton: "Cancel",
      enableButton: "Activate",
    },
  },
  specialtyCategories: {
    title: "Specialty Categories",
    description:
      "A classification that indicates the type of specialty certification, and includes different specialty categories such as medical, nursing, and pharmacy.",
    addSpecialtyCategory: "Add specialty category",
    editSpecialtyCategory: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Medical, Nursing, Pharmacy",
      },
      relatedBaseCertificationNames: {
        label: "Related Base Certifications",
        description:
          "Select the base certifications that are related to this specialty category.",
        placeholder: "Select base certifications",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
    },
  },
  specialtyCategoryLevels: {
    title: "Specialty Category Levels",
    description:
      "A classification that indicates the level of specialty certification, and includes different specialty category levels such as junior, senior, and expert.",
    addSpecialtyCategoryLevel: "Add specialty category level",
    editSpecialtyCategoryLevel: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in the specialty category.",
        placeholder: "Junior, Senior, Expert",
      },
      specialtyCategoryId: {
        label: "Specialty Category",
        description:
          "Select the specialty category that this level belongs to.",
        placeholder: "Medical, Nursing, Pharmacy",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
    },
  },
  issuingOrganizations: {
    title: "Issuing Organizations",
    description:
      "Organizations that issue certifications, including government agencies, professional societies, and corporations.",
    addIssuingOrganization: "Add issuing organization",
    editIssuingOrganization: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name...",
    form: {
      issuerOrganizationName: {
        label: "Organization Name",
        description: "Name should be unique in your organization.",
        placeholder: "Ministry of Health, Professional Association",
      },
      organizationType: {
        label: "Organization Type",
        description: "Select the type of organization.",
        placeholder: "Government, Society, Corporation",
      },
      address: {
        label: "Address",
        description: "Address of the organization.",
      },
      phoneNumber: {
        label: "Phone Number",
        description: "Contact phone number.",
      },
      email: {
        label: "Email",
        description: "Contact email address.",
      },
      url: {
        label: "URL",
        description: "Organization website URL.",
        placeholder: "https://example.com",
      },
      remarks: {
        label: "Remarks",
        description: "Additional notes or comments.",
        placeholder: "Additional information",
      },
    },
  },
};
